import React from 'react';
import { observer, inject } from 'mobx-react';

import { Box } from 'grommet';

import ContentsButton from 'app/components/MainMenu/ContentsButton';
import BookmarksButton from 'app/components/MainMenu/BookmarksButton';
import BookmarkingButton from 'app/components/MainMenu/BookmarkingButton';
import SearchButton from 'app/components/MainMenu/SearchButton';
import SearchInput from 'app/components/MainMenu/SearchInput';
import NavigationButtons from 'app/components/MainMenu/NavigationButtons';

function MainMenu({ AppState }) {
  if (!AppState.isMainMenuBar) return null;
  return (
    <React.Fragment>
      <Box direction="row" align="center">
        <ContentsButton />
        <SearchButton />
      </Box>
      <SearchInput />
      <NavigationButtons />
      <Box direction="row" align="center">
        <BookmarksButton />
        <BookmarkingButton />
      </Box>
    </React.Fragment>
  );
}

export default inject('AppState')(observer(MainMenu));



// WEBPACK FOOTER //
// ./src/app/components/MainMenu/MainMenu.js